import { MCarousel } from 'src/lib';

import { SecurityDetailsChart } from './SecurityDetailsChart';
import { SecurityDetailsStats } from './SecurityDetailsStats';

interface SecurityDetailsCarouselProps {
  symbol?: string;
}

export const SecurityDetailsCarousel = ({ symbol }: SecurityDetailsCarouselProps) => {
  return (
    <MCarousel>
      <SecurityDetailsStats symbol={symbol} />
      <SecurityDetailsChart symbol={symbol} />
    </MCarousel>
  );
};
